import { useMemo } from "react";
import type { CSSProperties } from "react";

/** Stable SparklinesLine style for vertical dashboard KPI strips (stroke follows theme). */
export function useKpiSparklineLineStyle(strokeColor: string): CSSProperties {
  return useMemo(
    () => ({
      strokeWidth: 2,
      stroke: strokeColor,
      fill: "none" as const
    }),
    [strokeColor]
  );
}
